import { LOGOUT } from './auth';

const LOAD = 'affiliate/LOAD';
const LOAD_SUCCESS = 'affiliate/LOAD_SUCCESS';
const LOAD_FAIL = 'affiliate/LOAD_FAIL';
const SIGNUP = 'affiliate/SIGNUP';
const SIGNUP_SUCCESS = 'affiliate/SIGNUP_SUCCESS';
const SIGNUP_FAIL = 'affiliate/SIGNUP_FAIL';
const VERIFY_EMAIL = 'affiliate/VERIFY_EMAIL';
const VERIFY_EMAIL_SUCCESS = 'affiliate/VERIFY_EMAIL_SUCCESS';
const VERIFY_EMAIL_FAIL = 'affiliate/VERIFY_EMAIL_FAIL';
const UPDATE_SETTINGS = 'affiliate/UPDATE_SETTINGS';
const UPDATE_SETTINGS_SUCCESS = 'affiliate/UPDATE_SETTINGS_SUCCESS';
const UPDATE_SETTINGS_FAIL = 'affiliate/UPDATE_SETTINGS_FAIL';

const initialState = {
  loaded: false,
};

export default function affiliate(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SUCCESS:
      return {
        ...state,
        ...action.result,
        loaded: true,
      };
    case LOAD_FAIL:
      return {
        ...state,
        loaded: true,
      };
    case SIGNUP_SUCCESS:
      return {
        ...state,
        email: action.result,
        status: 'PENDING',
      };
    case VERIFY_EMAIL_SUCCESS:
      if (action.result.email) {
        return { state, email: action.result.email };
      }
      return {
        ...state,
        status: 'REVIEWING',
      };
    case VERIFY_EMAIL_FAIL:
      return {
        ...state,
        status: 'PENDING',
      };
    case UPDATE_SETTINGS_SUCCESS:
      return {
        ...state,
        ...action.result,
      };
    case LOGOUT:
      return { ...initialState, loaded: true };
    default:
      return state;
  }
}

export function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: async ({ client }) => client.get('/api/v1/affiliate/account/info'),
  };
}
export function signUp(registrationData) {
  return {
    types: [SIGNUP, SIGNUP_SUCCESS, SIGNUP_FAIL],
    promise: async ({ client }) => {
      await client.post('/api/v1/affiliate/auth/signup', registrationData);
      return registrationData.email;
    },
  };
}
export function verifyEmail(authToken) {
  return {
    types: [VERIFY_EMAIL, VERIFY_EMAIL_SUCCESS, VERIFY_EMAIL_FAIL],
    promise: async ({ client }) => client.post(`/affiliate/auth/verify/${authToken}`),
  };
}
export function updateSettings(updates) {
  /* eslint-disable camelcase */
  return {
    types: [UPDATE_SETTINGS, UPDATE_SETTINGS_SUCCESS, UPDATE_SETTINGS_FAIL],
    promise: async ({ client }) => {
      const { payout_limit, report_enable } = updates;
      if (payout_limit) {
        await client.put('/api/v1/affiliate/account/payoutlimit', { payout_limit });
      } else if (report_enable) {
        await client.put('/api/v1/affiliate/account/report', { report_enable });
      }
      return updates;
    },
  };
  /* eslint-enable */
}
